<template>
  <v-g-editor ref="vgEditor" id='vg-editor' class="work-flow-graph">
    <div class="graph">
      <div class="graph__header">
        <flow-tool-bar/>
      </div>
      <div class="graph__container">
        <div class="graph__container__sidebar">
          <flow-item-panel/>
        </div>
        <div class="graph__container__main">
          <flow :data='workflow' :graph="{ mode: 'readOnly' }" :grid='grid' height='100%'/>
        </div>
      </div>
    </div>
    <flow-custom-node/>
    <flow-action-custom-node/>
    <flow-context-menu/>
  </v-g-editor>
</template>

<script>
import VGEditor, {
  Flow,
} from 'vg-editor';
import FlowToolBar from '@/components/WorkFlowGraphEditor/FlowToolBar.vue';
import FlowContextMenu from '@/components/WorkFlowGraphEditor/FlowContexMenu.vue';
import FlowItemPanel from '@/components/WorkFlowGraphEditor/FlowItemPanel.vue';
import FlowCustomNode from '@/components/WorkFlowGraphEditor/CustomNodes/FlowCustomNode.vue';
import FlowActionCustomNode from '@/components/WorkFlowGraphEditor/CustomNodes/FlowActionCustomNode.vue';

export default {
  name: 'WorkFlowGraphEditor',
  props: {
    workflow: {
      type: Object,
      required: true,
    },
  },
  computed: {
    grid() {
      return {
        cell: 25,
      };
    },
  },
  components: {
    FlowCustomNode,
    VGEditor,
    Flow,
    FlowToolBar,
    FlowContextMenu,
    FlowItemPanel,
    FlowActionCustomNode,
  },
};
</script>
<style scoped lang='scss'>
.work-flow-graph {
  display: flex;
  width: 100%;
  height: 100%;
  .graph {
    .graph-container{
      width: 100%;
    }
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 700px;
    display: flex;
    flex-direction: column;
    &__header {
      border: 1px solid var(--border-primary);
      padding: 8px;
      background-color: var(--bg-primary);
    }

    &__container {
      flex: 1;
      display: flex;
      &__sidebar {
        min-width: 208px;
        background-color: var(--bg-secondary);
        border-right: 1px solid var(--border-primary);
        display: flex;
        justify-content: center;
        max-height: 710px;
        overflow-y: auto;
      }
      &__main {
        flex: 1;
        .graph-container{
          min-height: 700px !important;
        }
      }
    }

    &__panel {
      width: 18%;
      background-color: var(--bg-secondary);
      border-left: 1px solid var(--border-primary);
    }
  }
}
</style>
